import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
  className?: string;
};
export function Countdown({
  tone = "light",
  className = ""
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  const dark = tone === "dark";
  return <div className={`text-center ${className}`} role="timer" aria-live="off" data-id="element-19" data-mp="3h1icnqaosz0j">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? "text-cream" : "text-brand"}`} data-id="element-20" data-mp="323pyp2ksgiog">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="373ugcvxfnjg9" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-22" data-mp="10dmwxh4j695w">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="15awjmp0jc6q1" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="y16jr6qc1zp4">
              <span className={`grid h-[72px] w-[72px] place-items-center rounded-xl font-serif text-4xl font-extrabold tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${dark ? "bg-cream text-brand" : "bg-brand text-cream"}`} data-id="element-25" data-mp="xzlsbpzbewvh">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-cream/70" : "text-ink/60"}`} data-id="element-26" data-mp="f1somlgvaix1">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${dark ? "text-cream" : "text-brand"}`} aria-hidden="true" data-id="element-27" data-mp="o4k02l9qteoo">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}